angular.module 'zc.projects'

.directive 'zcLabelClearance', ->
  directive =
    restrict: 'E'
    scope: {
      campaign: '='
    }
    template: """
      <span
        class="small label label-warning"
        ng-show="isClearance">
        CLEARANCE
      </span>
    """

    link: (scope, element, attrs) ->
      scope.isClearance = scope.campaign.clearance_item_set_id?

  directive



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/zc_label_clearance.directive.coffee